<template>
    <b-dropdown variant="primary" class="dropdown-selector">

        <template v-slot:button-content>
            <template v-if="display_station">
                <span class="mr-2">{{ $t('field.location_' + display_station.id) }}</span>
                <span class="mr-2 location-name">{{ $t('field.name_' + display_station.id) }}</span>
            </template>
            <template v-else>-----</template>
        </template>

        <div class="dropdown-select-area">
            <b-dropdown-item v-for="(station, idx_station) in station_list" :key="'station-' + +idx_station"
                            :active="display_station.id == station.id"
                            @click="update_selected( station.id )">
                            <!-- {{ station.field }} -->
                            {{ $t('field.location_' + station.id) }}　{{ $t('field.name_' + station.id) }}
            </b-dropdown-item>
        </div>

    </b-dropdown>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: {

    },
    data () {
        return {
        }
    },
    mounted ()
    {
    },
    computed: {
        ...mapState({
            'display_station': state => state.data.display_station,
            'station_list': state => state.data.stations_info,
        }),
    },
    methods: {

        update_selected (station_code)
        {
            this.$store.commit('data/select_station', station_code)
        },

    },
}
</script>

<style lang="scss">

.dropdown-selector
{
    .location-name
    {
        color: #fe6357;
    }

    .dropdown-toggle
    {
        border-radius: 5px 50px 50px 5px !important;
    }
}

</style>
